import { Box, Button, Grid2, Typography, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import successImg from "../../assets/webshopSuccess.png";
import failureImg from "../../assets/failed.png";
import QRIMG from "../../assets/QRcode.png";
import footerImg from "../../assets/footerLogo.png";

import { FetchWidgetConfigDetails } from "../../api/HorecaWidget.service";

const WebshopSuccess = ({ status }) => {
  const navigate = useNavigate();

  const [langLoader, setLangLoader] = useState(true);
  const [languageWords, setLanguageWords] = useState({});

  const { webShopMenuPosition } = useSelector(
    (store) => store?.Webshop || {}
  );

 
  const widgetData = JSON.parse(localStorage.getItem("widget") || "{}");
  const { id, resType, lang, key } = widgetData;

  const orderId = JSON.parse(localStorage.getItem("orderId"));

  const fetchWidgetSettingsDetails = async (lang) => {
    try {
      setLangLoader(true);
      const response = await FetchWidgetConfigDetails(key, id, lang);

      if (response?.status !== 200 || !response?.data) {
        throw new Error("Failed to fetch widget settings");
      }

      const result = response.data.basicLanguages.reduce((acc, item) => {
        const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
        acc[tag] = item.widgetTranslateLanguages?.[0]?.name || "";
        return acc;
      }, {});

      setLanguageWords(result);
    } catch (error) {
      console.error("Language load error:", error);
    } finally {
      setLangLoader(false);
    }
  };

  useEffect(() => {
    if (lang && id && key) {
      fetchWidgetSettingsDetails(lang);
    }
  }, [lang, id, key]);

  // 🚦 SINGLE render gate
  const isReady =
    status &&
    id &&
    key &&
    !langLoader &&
    Object.keys(languageWords).length > 0;

  if (!isReady) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const isSuccess = status === "success";

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        p: { xs: 1, sm: 2, md: 3 },
      }}
    >
      {/* MAIN CONTENT */}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            width: { xs: 120, sm: 200, md: 300 },
            height: { xs: 120, sm: 150, md: 250 },
            mb: 2,
          }}
        >
          <img
            src={isSuccess ? successImg : failureImg}
            alt="status"
            style={{ width: "100%", height: "100%" }}
          />
        </Box>

        <Typography
          sx={{
            color: isSuccess ? "#F37120" : "red",
            fontSize: { xs: 20, sm: 28, md: 36 },
            fontWeight: 600,
            mb: 1,
          }}
        >
          {isSuccess
            ? languageWords?.Thankyou
            : languageWords?.paymentFailed}
        </Typography>

        <Typography sx={{ color: "#969BA0", fontSize: 12, mb: 3 }}>
          {languageWords?.SuccessInfo}
        </Typography>

        {isSuccess && (
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
              {languageWords?.OrderNumber} :
            </Typography>
            <Typography sx={{ color: "#F37120", fontSize: 36, fontWeight: 600 }}>
              {orderId}
            </Typography>
          </Box>
        )}

        {/* QR FOR KIOSK */}
        {resType === "kiosk" && isSuccess && (
          <Box mt={3}>
            <Box sx={{ width: 141, height: 134, mx: "auto", mb: 1 }}>
              <img src={QRIMG} alt="QR" style={{ width: "100%" }} />
            </Box>
            <Typography fontWeight="bold">Add Your Points</Typography>
            <Typography fontWeight="bold">To Your Account</Typography>
          </Box>
        )}
      </Box>

      {/* ACTION BUTTONS */}
      {isSuccess && (
        <Button
          sx={{ backgroundColor: "#F37120", color: "#fff", mb: 1 }}
          variant="contained"
          onClick={() =>
            navigate(
              `/widget?widgetsetupid=${id}&key=${key}&resType=${resType}&position=${webShopMenuPosition}`
            )
          }
        >
          {languageWords?.OrderAgain}
        </Button>
      )}

      <Button
        sx={{ backgroundColor: "grey", color: "#fff", mb: 2 }}
        variant="contained"
        onClick={() => navigate(-1)}
      >
        {languageWords?.GoBack}
      </Button>

      {/* FOOTER */}
      <Grid2 container spacing={2} alignItems="center" sx={{ width: "100%", pb: 2 }}>
        <Grid2 size={{ md: 1 }}>
          <img src={footerImg} alt="footer" style={{ width: 76 }} />
        </Grid2>
        <Grid2 size={{ md: 10 }}>
          <Typography sx={{ color: "#969BA0" }}>
            {languageWords?.FooterInfo}
          </Typography>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default WebshopSuccess;
